import React from "react";
import { motion } from "framer-motion";
import { BOAT_SPECS, BOAT_FEATURES, IMAGES } from "../data";
import { Check } from "lucide-react";

const Boat = () => {
  return (
    <section id="barco" className="relative py-24 md:py-32 overflow-hidden" data-testid="boat-section">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-12 gap-10 items-start">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="md:col-span-5 md:sticky md:top-28"
          >
            <div className="overline mb-4">Sua casa flutuante</div>
            <h2 className="font-display text-5xl md:text-6xl font-light leading-[1] tracking-tight">
              ZEUS<span style={{ color: "var(--ocean-accent)" }}>.</span>
            </h2>
            <p className="mt-4 font-display text-2xl font-light" style={{ color: "var(--ocean-muted)" }}>
              50 pés. Onze hóspedes. Quatro cabines.
            </p>
            <div className="divider-grad my-8 max-w-[200px]" />
            <p className="text-base leading-relaxed" style={{ color: "var(--ocean-muted)" }}>
              Catamarã com propulsão a motor, projetado para o conforto em alto-mar.
              <strong className="text-white font-normal"> 1 suíte casal, 1 suíte tripla, 1 quarto casal e 1 quarto quádruplo</strong> —
              com 4 banheiros (2 nas suítes + masculino e feminino externos),
              cozinha completa e infraestrutura profissional de mergulho.
            </p>

            <div className="mt-10 grid grid-cols-2 gap-x-6 gap-y-4">
              {BOAT_SPECS.map((spec) => (
                <div key={spec.label} className="kbd-line pl-10">
                  <div className="overline text-[0.6rem]" style={{ color: "var(--ocean-accent)" }}>
                    {spec.label}
                  </div>
                  <div className="font-display text-lg leading-tight">{spec.value}</div>
                </div>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="md:col-span-7 space-y-3"
          >
            <div className="relative h-[420px] overflow-hidden">
              <img src={IMAGES.catamaran} alt="Catamarã ZEUS navegando" className="w-full h-full object-cover" />
              <div className="absolute bottom-4 left-4 glass px-3 py-1.5 text-xs">EXTERIOR · ZEUS EXPLORER</div>
            </div>
            <div className="grid grid-cols-2 gap-3 h-[220px]">
              <div className="relative overflow-hidden">
                <img src={IMAGES.zeusAerial} alt="Vista aérea do catamarã ZEUS" className="w-full h-full object-cover" />
                <div className="absolute bottom-3 left-3 glass px-3 py-1.5 text-xs">VISTA AÉREA · CONVÉS</div>
              </div>
              <div className="relative overflow-hidden">
                <img src={IMAGES.zeusSala} alt="Sala de estar do catamarã ZEUS" className="w-full h-full object-cover" />
                <div className="absolute bottom-3 left-3 glass px-3 py-1.5 text-xs">SALA DE ESTAR</div>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3 h-[220px]">
              <div className="relative overflow-hidden">
                <img src={IMAGES.zeusCabinCasal} alt="Quarto casal" className="w-full h-full object-cover" />
                <div className="absolute bottom-3 left-3 glass px-3 py-1.5 text-xs">QUARTO CASAL</div>
              </div>
              <div className="relative overflow-hidden">
                <img src={IMAGES.zeusCabinTriplo} alt="Quarto triplo" className="w-full h-full object-cover" />
                <div className="absolute bottom-3 left-3 glass px-3 py-1.5 text-xs">QUARTO TRIPLO</div>
              </div>
            </div>

            <div className="glass p-8 mt-6">
              <div className="overline mb-4">A bordo, tudo isso</div>
              <ul className="grid sm:grid-cols-2 gap-y-3 gap-x-6">
                {BOAT_FEATURES.map((f) => (
                  <li key={f} className="flex items-start gap-3 text-sm">
                    <Check size={16} style={{ color: "var(--ocean-accent)", marginTop: 2 }} />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Boat;
